<template>
  <div>
    <WizardBlindCheckStep
      v-if="wizardStep === 1"
      :handleNextStep="onNextStepClick"
    />
    <WizardBlindDeviceRegistStep
      v-if="wizardStep === 2"
      :handleNextStep="onNextStepClick"
      :serial="serialCode"
    />
    <WizardBlindRegistCompleteStep
      v-if="wizardStep === 3"
      :handleNextStep="onNextStepClick"
    />
  </div>
</template>

<script setup>
import { getCurrentInstance, onBeforeMount, onBeforeUnmount, ref } from 'vue';

import WizardBlindCheckStep from './components/wizard/WizardBlindCheckStep';
import WizardBlindDeviceRegistStep from './components/wizard/WizardBlindDeviceRegistStep';
import WizardBlindRegistCompleteStep from './components/wizard/WizardBlindRegistCompleteStep';

const { emitter } =
  getCurrentInstance().appContext.config.globalProperties;

const wizardStep = ref(1);
const serialCode = ref('');

const onNextStepClick = async (params) => {
  try {
    if (wizardStep.value === 1) {
      serialCode.value = params.serialCode;
    } else if (wizardStep.value === 2) {
    } else if (wizardStep.value === 3) {
    } else {
      return;
    }

    wizardStep.value += 1;
  } catch (err) {
    console.log(err);
    if (err?.length > 0) {
      emitter.emit('showPopAlert', { description: err });
    }
  }
};

onBeforeMount(() => {
  emitter.emit('onChangeHeaderSetting',{title:'블라인드 등록',isShowMenu:false,isShowZone:false,isShowProfile:false});
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});
})
</script>
